import { type IMap } from '@/Root/Types/MapTypes'

interface IToolPropsOptions {
  enabled?: boolean
  options?: object
}

interface IToolProps extends IToolPropsOptions {
  map: IMap
}
interface ITool {
  enable: () => void
  disable: () => void
}

interface IDrawToolPropsOptions extends IToolPropsOptions {
  shape?: EMapShape
  tool?: IDrawTool
}

interface IDrawToolProps extends IToolProps {
  shape?: EMapShape
  tool?: IDrawTool
}

enum EMapShape {
  polygon = 'Polygon',
  linestring = 'LineString',
  point = 'Point'
}

interface IDrawTool extends ITool {
  shape?: string
  setMapShape: (shape: EMapShape) => void
  getMapShape: () => EMapShape | undefined
  setGeojson: (geoJSON: GeoJSON.FeatureCollection) => void
  getGeojson: () => GeoJSON.FeatureCollection | undefined
  getEmptyGeojson: () => GeoJSON.FeatureCollection | undefined
  /* onStart: (listener: () => void) => void
  onUpdate: (listener: (geojson: GeoJSON.FeatureCollection) => void) => void
  onUpdateProgress: (listener: (geojson: GeoJSON.FeatureCollection) => void) => void
  onComplete: (listener: (geojson: GeoJSON.FeatureCollection) => void) => void */
  enableMapShape: (shape: EMapShape) => void
  disableMapShape: (shape: EMapShape) => void
  clearDrawings: () => void
  destroy: () => void
}
interface IPolygonQueryTool extends IDrawTool {

}

interface IProjectionTool extends ITool {

}

interface ITimeControl extends ITool {

}

interface IElevationControl extends ITool {

}

export type {
  IToolPropsOptions,
  IToolProps,
  IDrawToolPropsOptions,
  IDrawToolProps,
  ITool,
  IPolygonQueryTool,
  IDrawTool,
  IProjectionTool,
  ITimeControl,
  IElevationControl
}

export {
  EMapShape
}
